<template>
  <div>
    <div v-if="hasAnyAddon">
      <h6>{{ $t('planSubscription.overview.addons.header') }}:</h6>
      <div class="currentPlan mt-3" v-if="emailsList.length > 0">
        <div v-for="(email, index) in emailsList" :key="index">
          <div class="custom-separator my-3" v-if="index > 0"></div>
          <CRow>
            <CCol sm="3" class="">
              <div class="addonType">
                <CIcon name="email" size="custom-size" class="text-gray-500 pr-1 iconAddons" :height="25" viewBox="0 0 32 32" />
                {{ formatNumber(email.balance) }} E-mails
              </div>
            </CCol>
            <CCol v-if="isSubscribe" sm="2" class="">
              <div v-if="email.addOnOrganizationStatus == addonStatus.ACTIVE">
                <div class="subTextAddons">{{ $t('planSubscription.overview.addons.text.nextPayment') }}</div>
                <div class="textAddons">{{ formatStringMed(email.nextPayment) }}</div>
              </div>
              <div v-if="email.addOnOrganizationStatus == addonStatus.CANCELED">
                <div class="subTextAddons">{{ $t('planSubscription.overview.addons.text.Canceled') }}</div>
                <div class="textAddons">{{ formatStringMed(email.endDateTime) }}</div>
              </div>
            </CCol>
            <CCol v-if="isSubscribe" sm="2" class="">
              <div v-if="email.addOnOrganizationStatus == addonStatus.ACTIVE">
                <div class="subTextAddons">{{ $t('planSubscription.overview.addons.text.youWillPay') }}</div>
                <div class="textAddons">{{ formatCurrency(email.price) }}</div>
              </div>
            </CCol>
            <CCol v-if="isSubscribe" sm="5" class="colBtnIncrease">
              <div v-if="email.addOnOrganizationStatus == addonStatus.ACTIVE">
                <CButton @click="openCancelation(email.id, 'email')" class="px-4 mr-3" variant="outline" color="gray-500">{{
                  $t('planSubscription.overview.addons.button.cancel')
                }}</CButton>
                <CButton class="px-4" variant="outline" color="primary" @click="$router.push({ name: 'manage-balance' })">{{
                  $t('planSubscription.overview.addons.button.increase')
                }}</CButton>
              </div>
              <div v-if="email.addOnOrganizationStatus == addonStatus.CANCELED">
                <div class="subTextAddons pt-3">
                  {{ $t('planSubscription.overview.addons.text.canceledDate', { date: formatStringMed(email.updatedDateTime) }) }}
                </div>
              </div>
            </CCol>
          </CRow>
        </div>
      </div>

      <div class="currentPlan mt-3" v-if="smsList.length > 0">
        <div v-for="(sms, indexSms) in smsList" :key="indexSms">
          <div class="custom-separator my-3" v-if="indexSms > 0"></div>
          <CRow>
            <CCol sm="3" class="">
              <div class="addonType">
                <CRow>
                  <CCol sm="2">
                    <CIcon name="sms" size="custom-size" class="text-gray-500 pr-1 iconAddons" :height="25" viewBox="0 0 32 32" />
                  </CCol>
                  <CCol class="addonType-sms">
                    <div>{{ formatNumber(sms.balance) }} SMS</div>
                    <div class="addonType-sms-subtitle">({{ getFlag(sms.countryId) }})</div>
                  </CCol>
                </CRow>
              </div>
            </CCol>
            <!-- Coluna 2 -->
            <CCol v-if="isSubscribe" sm="2" class="">
              <div v-if="sms.addOnOrganizationStatus == addonStatus.ACTIVE">
                <div class="subTextAddons">{{ $t('planSubscription.overview.addons.text.nextPayment') }}</div>
                <div class="textAddons">{{ formatStringMed(sms.nextPayment) }}</div>
              </div>
              <div v-if="sms.addOnOrganizationStatus == addonStatus.CANCELED">
                <div class="subTextAddons">{{ $t('planSubscription.overview.addons.text.Canceled') }}</div>
                <div class="textAddons">{{ formatStringMed(sms.endDateTime) }}</div>
              </div>
            </CCol>
            <!-- Coluna 3 -->
            <CCol v-if="isSubscribe" sm="2" class="">
              <div v-if="sms.addOnOrganizationStatus == addonStatus.ACTIVE">
                <div class="subTextAddons">{{ $t('planSubscription.overview.addons.text.youWillPay') }}</div>
                <div class="textAddons">{{ formatCurrency(sms.price) }}</div>
              </div>
            </CCol>
            <!-- Coluna 4 -->
            <CCol v-if="isSubscribe" sm="5" class="colBtnIncrease">
              <div v-if="sms.addOnOrganizationStatus == addonStatus.ACTIVE">
                <CButton @click="openCancelation(sms.id, 'sms')" class="px-4 mr-3" variant="outline" color="gray-500">{{
                  $t('planSubscription.overview.addons.button.cancel')
                }}</CButton>
                <CButton class="px-4" variant="outline" color="primary" @click="$router.push({ name: 'manage-balance' })">{{
                  $t('planSubscription.overview.addons.button.increase')
                }}</CButton>
              </div>
              <div v-if="sms.addOnOrganizationStatus == addonStatus.CANCELED">
                <div class="subTextAddons pt-3">
                  {{ $t('planSubscription.overview.addons.text.canceledDate', { date: formatStringMed(sms.updatedDateTime) }) }}
                </div>
              </div>
            </CCol>
          </CRow>
        </div>
      </div>
    </div>
    <CModal :show.sync="isOpen" :no-close-on-backdrop="true">
      <div>
        <CRow>
          <CCol class="text-center">
            <img src="/img/create-segment.svg" class="" style="max-width: 250px" />
          </CCol>
        </CRow>
        <CRow>
          <CCol class="text-center h5">
            {{ $t('planSubscription.overview.addons.modal.doYouReally') }}
          </CCol>
        </CRow>

        <CRow alignHorizontal="center" class="mt-4">
          <CCol sm="10" class="text-center text-gray-100">
            <p v-html="$t('planSubscription.overview.addons.modal.text', { nextInvoice: `<strong>${formatDateString(nextInvoice)}</strong>` })"></p>
          </CCol>
        </CRow>

        <div class="text-center mt-4">
          <CButton @click="closeCancelation()" class="px-4 py-2 mr-3" color="white">{{
            $t('planSubscription.overview.addons.modal.button.back')
          }}</CButton>
          <CButton @click="cancelAddon()" class="px-4 py-2" color="primary">{{ $t('planSubscription.overview.addons.modal.button.cancel') }}</CButton>
        </div>
      </div>

      <template #footer>
        <div></div>
      </template>
    </CModal>
  </div>
</template>

<script>
import { nameCountries } from '@/utils/countriesUtils.js'
import { formatNumber, currencyFormat } from '@/utils/numbersFormatUtil.js'
import { dateFormatStringMed, dateFormatString } from '@/utils/dateUtil'
import services from '@/services.js'

const AddonStatusEnum = {
  ACTIVE: 1,
  DELETED: 2,
  CANCELED: 3,
  SUSPENDED: 4,
}

export default {
  name: 'OverViewAddons',
  components: {},
  props: {
    addons: {
      type: Object,
      default: () => {},
    },
    isSubscribe: {
      type: Boolean,
      default: false,
    },
    nextInvoice: {
      type: String,
      default: new Date().toISOString(),
    },
  },
  data() {
    return {
      emailsList: [],
      smsList: [],
      isOpen: false,
      selectedCancelAddon: null,
      cancelationType: null,
      addonStatus: AddonStatusEnum,
    }
  },
  mounted() {
    this.processAddons()
    this.getFlag('EG')
  },
  methods: {
    openCancelation(id, type) {
      this.isOpen = true
      this.selectedCancelAddon = id
      this.cancelationType = type
    },

    closeCancelation() {
      this.isOpen = false
      this.selectedCancelAddon = null
    },

    cancelAddon() {
      switch (this.cancelationType) {
        case 'email':
          this.cancelAddonEmail(this.selectedCancelAddon)
          break
        case 'sms':
          this.cancelAddonSms(this.selectedCancelAddon)
          break

        default:
          break
      }
    },

    cancelAddonEmail(id) {
      let organizationId = this.$route.params.organizationId
      services
        .cancelAddonEmail(organizationId, id)
        .then(() => {
          let obj = {
            status: 'success',
            text: 'planSubscription.overview.addons.cancelationAddonSuccess',
          }
          this.$emit('cancelAddonSuccess', obj)
        })
        .catch(({ response }) => {
          let error = {
            status: 'danger',
            text: response.data.message || 'Erro',
          }
          this.$emit('cancelAddonError', error)
        })
        .finally(() => {
          this.isOpen = false
          this.selectedCancelAddon = null
          this.cancelationType = null
        })
    },
    cancelAddonSms(id) {
      let organizationId = this.$route.params.organizationId
      services
        .cancelAddonSMS(organizationId, id)
        .then(() => {
          let obj = {
            status: 'success',
            text: 'planSubscription.overview.addons.cancelationAddonSuccess',
          }
          this.$emit('cancelAddonSuccess', obj)
        })
        .catch(({ response }) => {
          let error = {
            status: 'danger',
            text: response.data.message || 'Erro',
          }
          this.$emit('cancelAddonError', error)
        })
        .finally(() => {
          this.isOpen = false
          this.selectedCancelAddon = null
          this.cancelationType = null
        })
    },

    processAddons() {
      if (Object.keys(this.addons).length > 0) {
        this.processEmail()
        this.processSMS()
      }
    },

    processEmail() {
      this.emailsList = this.addons.email?.recurrentAddOns
    },

    processSMS() {
      this.smsList = this.addons.sms?.recurrentAddOns
    },

    formatNumber(value) {
      return formatNumber(value)
    },

    getFlag(key) {
      const item = nameCountries(this).find((elm) => elm.value == key)
      return item.label
    },

    formatStringMed(date) {
      return dateFormatStringMed(date)
    },

    formatCurrency(value) {
      return currencyFormat(value)
    },

    formatDateString(date) {
      return dateFormatString(date)
    },
  },

  computed: {
    hasAnyAddon: function () {
      return this.emailsList.length > 0 || this.smsList.length > 0
    },
  },
}
</script>

<style lang="scss" scope>
.subTextAddons {
  color: #868e96;
  font-size: 12px;
}

.textAddons {
  font-size: 16px;
  color: #343a40;
  font-weight: bold;
}

.iconAddons {
  margin-right: 10px;
}

.addonType {
  font-size: 16px;
  color: #343a40;
  font-weight: bold;
  line-height: 2.8;
}

.addonType-sms {
  line-height: 1.5;
}

.addonType-sms-subtitle {
  color: $gray-600;
  font-size: 12px;
  font-weight: normal;
}

.currentPlan {
  border-radius: 10px;
  border: 1px solid #dee2e6;
  padding: 20px;
}

.colBtnIncrease {
  text-align: right;
}

.custom-separator {
  border-top: 1px solid #dee2e6;
}

.checkMark {
  color: $primary;
}

.blockFeatures {
  color: #343a40;
  font-size: 14px;
}
</style>
